export enum STRATEGY_TYPE_ENUM {
  Originals = 'uTrade Originals',
  // commented for RA-3863
  // Created = 'Created Strategies'   
}

export enum Product_Type {
  Intraday = 'Intraday',
  CarryForward = 'Carry Forward'
}

export enum PRODUCT_ID {
  ALL = 'ALL',
}

export enum TRANSACTION_MODE_ENUM {
  ALL = 'all',
  WITHDRAW = "withdraw",
  DEPOSIT = 'deposit'
}

export enum TransactionStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS',
  Pending = 'PENDING',
  Initiated = 'INITIATED',
  Cancelled = 'CANCELLED'
}

export enum TransactionStatusStyles {
  FAILED = 'failure',
  SUCCESS = 'success',
  PENDING = 'pending'
}

 